import axios from 'axios';
import { token } from '../../../services/Apis';
import { juegosDeportivosApi } from '../../sistema/deportes/DeportesService';

export const JUEGOS_CONST = 'juegos';

export const allJuegosService = async (params) => {
  const res = await axios.get(`${juegosDeportivosApi}/${JUEGOS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveJuegosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(
      `${juegosDeportivosApi}/${JUEGOS_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  } else {
    res = await axios.post(`${juegosDeportivosApi}/${JUEGOS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneJuegosService = async (id) => {
  const res = await axios.get(`${juegosDeportivosApi}/${JUEGOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteJuegosService = async (id) => {
  const res = await axios.delete(
    `${juegosDeportivosApi}/${JUEGOS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
